import { render } from "./InputImage.vue?vue&type=template&id=b7b7b63e"
import script from "./InputImage.vue?vue&type=script&lang=js"
export * from "./InputImage.vue?vue&type=script&lang=js"
script.render = render

export default script